var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.983 3.172a.77.77 0 00-.97 0L1.205 6.524c-.437.373-.123 1.024.478 1.024H4.14v7.246c0 .663.614 1.206 1.365 1.206s1.366-.543 1.366-1.206V7.548h2.444c.615 0 .915-.65.478-1.024l-3.81-3.352zM19.796 15.48c.437-.374.123-1.024-.479-1.024h-2.448V7.205c0-.663-.615-1.205-1.368-1.205-.752 0-1.367.542-1.367 1.205v7.24h-2.448c-.616 0-.916.65-.479 1.024l3.816 3.349c.26.24.697.24.957.012l3.816-3.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrows);
export default __webpack_public_path__ + "static/media/double-arrows.57571d80.svg";
export { ForwardRef as ReactComponent };